import { Component, ElementRef, HostBinding } from '@angular/core';

@Component({
    selector: 'app-page-scroll-content',
    templateUrl: './page-scroll-content.component.html',
    styleUrl: './page-scroll-content.component.scss',
    standalone: true
})
export class PageScrollContentComponent {

    @HostBinding('class') classes = 'body-container-body scrollbox'

    constructor(public pageScrolls: ElementRef) { }

    scrollToTop(): void {
        this.pageScrolls.nativeElement.scrollTop = 0
    }

    scrollToBottom(): void {
        let e: HTMLElement = this.pageScrolls.nativeElement
        this.pageScrolls.nativeElement.scrollTop = e.scrollHeight
    }

    scrollToElement(element: HTMLElement): void {
        element.scrollIntoView({ behavior: 'auto', block: 'center', inline: 'nearest' })
    } 

}
